import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Calculator, CheckSquare, FileText, GitCompare, Receipt } from 'lucide-react';

const TOOLS = [
  { label: 'EMI Calculator', href: '/emi-calculator', icon: Calculator },
  { label: 'Eligibility Calculator', href: '/eligibility-calculator', icon: CheckSquare },
  { label: 'Documents Required', href: '/documents', icon: FileText },
  { label: 'Loan Comparison', href: '/loan-comparison', icon: GitCompare },
  { label: 'Charges Calculator', href: '/charges-calculator', icon: Receipt },
];

const ToolNav = () => {
  const { pathname } = useLocation();

  return (
    <div className="bg-white/90 backdrop-blur border-b border-[#0b2545]/10 sticky top-[72px] z-30">
      <div className="max-w-[1240px] mx-auto px-4 lg:px-6">
        <div className="flex items-center gap-1 overflow-x-auto scrollbar-none py-1.5">
          {TOOLS.map(({ label, href, icon: Icon }) => {
            const active = pathname === href;
            return (
              <Link
                key={href}
                to={href}
                className={`relative flex items-center gap-1.5 whitespace-nowrap px-3.5 py-2.5 text-[13px] font-semibold rounded-lg transition-all ${
                  active
                    ? 'text-white shadow-sm'
                    : 'text-slate-600 hover:text-[#1e73be] hover:bg-[#1e73be]/5'
                }`}
                style={active ? { background: 'linear-gradient(135deg,#1e73be,#155a99)' } : undefined}
              >
                <Icon className={`w-3.5 h-3.5 flex-shrink-0 ${active ? 'text-[#e8c887]' : 'text-slate-400'}`} />
                {label}
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ToolNav;
